module.exports = __webpack_public_path__ + "static/img/user_bg.c01128df.png";